<template>
  <a-modal
    :title="title"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :width="800"
    :footer="null"
    @cancel="cancelHandel"
  >
    <a-row>
      <a-col :xs="24" :md="12" :style="{ height: '350px' }">
        <vue-cropper
          ref="cropper"
          :img="options.img"
          :info="true"
          :autoCrop="options.autoCrop"
          :autoCropWidth="options.autoCropWidth"
          :autoCropHeight="options.autoCropHeight"
          :fixedBox="options.fixedBox"
          :outputType="options.outputType"
          @realTime="realTime"
        ></vue-cropper>
      </a-col>
      <a-col :xs="24" :md="12" :style="{ height: '350px' }">
        <div class="avatar-upload-preview">
          <img :src="previews.url" :style="previews.img" />
        </div>
      </a-col>
    </a-row>
    <br />
    <a-row>
      <a-col :lg="2" :md="2">
        <a-upload
          name="file"
          :beforeUpload="beforeUpload"
          :showUploadList="false"
          :loading="uploading"
        >
          <a-button icon="upload">选择图片</a-button>
        </a-upload>
      </a-col>
      <a-col :lg="{ span: 1, offset: 2 }" :md="2">
        <a-button icon="plus" @click="changeScale(1)" />
      </a-col>
      <a-col :lg="{ span: 1, offset: 1 }" :md="2">
        <a-button icon="minus" @click="changeScale(-1)" />
      </a-col>
      <a-col :lg="{ span: 1, offset: 1 }" :md="2">
        <a-button icon="undo" @click="rotateLeft" />
      </a-col>
      <a-col :lg="{ span: 1, offset: 1 }" :md="2">
        <a-button icon="redo" @click="rotateRight" />
      </a-col>
      <a-col :lg="{ span: 2, offset: 6 }" :md="2">
        <a-button
          type="primary"
          :disabled="!options.img"
          @click="finish('blob')"
        >
          保存
        </a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import { VueCropper } from 'vue-cropper'

export default {
  name: 'LogoModal',
  data() {
    return {
      visible: false,
      // id: null,
      confirmLoading: false,
      fileList: [],
      uploading: false,
      options: {
        img: '',
        outputType: 'png',
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true,
      },
      previews: {},
      file: null,
    }
  },
  props: ['title', 'suffixs', 'maxSize', 'type'],
  methods: {
    edit() {
      this.visible = true
      // this.id = id
      /* 获取原始头像 */
    },
    close() {
      // this.id = null
      this.visible = false
    },
    cancelHandel() {
      this.close()
    },
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },

    validateSuffix(file) {
      const suffixs = this.suffixs
      if (!suffixs) {
        return true
      }
      const suffix = file.name
        .toLowerCase()
        .split('.')
        .splice(-1)
        .join('')
      if (suffixs.includes(suffix)) {
        return true
      }
      this.$message.warning(`仅支持${suffixs.join(', ')}格式`)
      return false
    },
    validateSize(file) {
      const maxSize = this.maxSize
      if (!maxSize) {
        return true
      }
      const size = file.size
      if (size < maxSize * 1024 * 1024) {
        return true
      }
      this.$message.warning(`上传文件大小不能超过 ${maxSize}MB`)
      return false
    },
    validate(file) {
      const validateMethods = ['validateSuffix', 'validateSize']
      return validateMethods.every(method => {
        return this[method](file)
      })
    },
    beforeUpload(file) {
      if (this.uploading) {
        return false
      }
      const check = this.validate(file)
      if (!check) {
        return false
      }
      this.file = file
      const reader = new FileReader()
      // 把Array Buffer转化为blob 如果是base64不需要
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.options.img = reader.result
      }
      // 转化为blob
      // reader.readAsArrayBuffer(file)
      return false
    },

    // 上传图片（点击上传按钮）
    finish(type) {
      const formData = new FormData()
      // 输出
      if (type === 'blob') {
        this.$refs.cropper.getCropBlob(data => {
          const img = window.URL.createObjectURL(data)
          this.model = true
          this.modelSrc = img
          formData.append('file', data, this.file.name)
          formData.append('type', this.type)
          this.uploading = true
          this.$emit('ok', formData)
        })
      } else {
        this.$refs.cropper.getCropData(data => {
          this.model = true
          this.modelSrc = data
        })
      }
    },
    closeLoading() {
      this.uploading = false
    },
    realTime(data) {
      this.previews = data
    },
  },
  components: {
    VueCropper,
  },
}
</script>

<style lang="less" scoped>
.avatar-upload-preview {
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
  width: 200px;
  height: 200px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
